import React, { useState, useEffect } from 'react';
import { Clock, LogOut } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const SessionIndicator = ({ timeoutMinutes = 30, onLogout }) => {
  const { user } = useAuth();
  const [lastActivity, setLastActivity] = useState(Date.now());
  const [timeRemaining, setTimeRemaining] = useState(timeoutMinutes * 60);
  const [isVisible, setIsVisible] = useState(false);

  // Atualizar atividade quando houver interação
  useEffect(() => {
    const updateActivity = () => {
      setLastActivity(Date.now());
    };

    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
    
    events.forEach(event => {
      document.addEventListener(event, updateActivity, true);
    });

    return () => {
      events.forEach(event => {
        document.removeEventListener(event, updateActivity, true);
      });
    };
  }, []);

  // Calcular tempo restante
  useEffect(() => {
    if (!user) return;

    const interval = setInterval(() => {
      const now = Date.now();
      const timeSinceActivity = now - lastActivity;
      const timeoutMs = timeoutMinutes * 60 * 1000;
      const remaining = Math.max(0, timeoutMs - timeSinceActivity);
      const remainingSeconds = Math.floor(remaining / 1000);
      
      setTimeRemaining(remainingSeconds);
      
      // Mostrar indicador nos últimos 10 minutos
      setIsVisible(remainingSeconds <= 600 && remainingSeconds > 0);
    }, 1000);

    return () => clearInterval(interval);
  }, [user, lastActivity, timeoutMinutes]);

  // Formatar tempo restante
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs.toString().padStart(2, '0')}`;
  };

  // Não mostrar se usuário não estiver logado ou se há muito tempo restante
  if (!user || !isVisible) return null;

  return (
    <div className={`fixed top-4 right-4 z-50 transition-all duration-300 ${
      timeRemaining <= 300 ? 'animate-pulse' : ''
    }`}>
      <div className={`flex items-center space-x-2 px-3 py-2 rounded-lg shadow-lg text-sm ${
        timeRemaining <= 300 
          ? 'bg-red-100 border border-red-300 text-red-700' 
          : 'bg-yellow-100 border border-yellow-300 text-yellow-700'
      }`}>
        <Clock className="w-4 h-4" />
        <span>Sessão expira em: {formatTime(timeRemaining)}</span>
        {onLogout && (
          <button
            onClick={onLogout}
            className="ml-2 p-1 hover:bg-black hover:bg-opacity-10 rounded transition-colors"
            title="Fazer logout"
          >
            <LogOut className="w-3 h-3" />
          </button>
        )}
      </div>
    </div>
  );
};

export default SessionIndicator;
